<div class="view-container stocktake-reports-page">
  <div class="mbp-page-header stocktake-reports-page__header">
    <div class="mbp-page-header__icon">
      <mat-icon>assessment</mat-icon>
    </div>
    <div>
      <h1 class="mbp-page-header__title">Stocktake reports</h1>
      <p class="mbp-page-header__subtitle">Download stock difference and scanned stock reports</p>
    </div>
  </div>

  <div class="stocktake-reports-page__grid row g-2">
    <div class="col-lg-6">
      <mat-card class="stocktake-reports-section">
        <h2 class="stocktake-reports-section__title">Stock difference</h2>

        <form [formGroup]="diffDateRangeForm" class="stocktake-reports-section__filters">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="stocktake-reports-section__date-field"
            subscriptSizing="dynamic"
          >
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="diffPicker">
              <input formControlName="start" matStartDate placeholder="Start date">
              <input formControlName="end" matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="diffPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #diffPicker></mat-date-range-picker>
          </mat-form-field>
        </form>

        <div class="stocktake-reports-section__actions">
          <div class="stocktake-reports-section__action-row">
            <mat-form-field
              appearance="outline"
              class="stocktake-reports-section__select stocktake-reports-section__select--action"
              subscriptSizing="dynamic"
            >
              <mat-select
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadDiffReportControl"
              >
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="stocktake-reports-section__btn"
              mat-stroked-button
              [disabled]="downloadDiffReportControl.invalid || diffDateRangeForm.invalid"
              (click)="generateAndDownloadDiff()"
            >
              <mat-icon>file_download</mat-icon>
              Download
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <div class="col-lg-6">
      <mat-card class="stocktake-reports-section">
        <h2 class="stocktake-reports-section__title">Scanned stock</h2>

        <form [formGroup]="scannedDateRangeForm" class="stocktake-reports-section__filters">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="stocktake-reports-section__date-field"
            subscriptSizing="dynamic"
          >
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="scannedPicker">
              <input formControlName="start" matStartDate placeholder="Start date">
              <input formControlName="end" matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="scannedPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #scannedPicker></mat-date-range-picker>
          </mat-form-field>
        </form>

        <div class="stocktake-reports-section__actions">
          <div class="stocktake-reports-section__action-row">
            <mat-form-field
              appearance="outline"
              class="stocktake-reports-section__select stocktake-reports-section__select--action"
              subscriptSizing="dynamic"
            >
              <mat-select
                placeholder="Report type"
                aria-label="Report type"
                [formControl]="downloadScannedReportControl"
              >
                <mat-option value="csv">CSV</mat-option>
                <mat-option value="excel">Excel</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              type="button"
              class="stocktake-reports-section__btn"
              mat-stroked-button
              [disabled]="downloadScannedReportControl.invalid || scannedDateRangeForm.invalid"
              (click)="generateAndDownloadScanned()"
            >
              <mat-icon>file_download</mat-icon>
              Download
            </button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
